export const iosAppDownloadUrl = 'https://apps.apple.com/br/app/medprev/id1295213329';
export const androidAppDownloadUrl = 'https://play.google.com/store/apps/details?id=online.medprev.app';
export const medprevOnlineUrl = 'https://agendamento.medprev.app/';
